export class UserDetail {
  id: number;
  userId: number | null;
  company: string | null;
  phoneNumber: string | null;
  address: string | null;
  city: string | null;
  state: string | null;
  country: string | null;
  postalCode: string | null;
  taxOffice: string | null;
  taxNumber: string | null;
  passiveDt: Date | null;
  authProvider: string | null;
  notifyToken: string | null;
  profilePictureUrl: string | null;
  lastSessionBy: string | null;
  passwordExpireDt: Date | null;
  isMultiSession: boolean | null;
  createdBy: string | null;
  createdDt: Date | null;
  updatedBy: string | null;
  updatedDt: Date | null;

  username: string | null;
  firsName: string | null;
  lastName: string | null;
  email: string | null;
  role: string | null;

  constructor(data?: Partial<UserDetail>) {
    this.id = data?.id ?? 0;
    this.userId = data?.userId ?? null;
    this.company = data?.company ?? null;
    this.phoneNumber = data?.phoneNumber ?? null;
    this.address = data?.address ?? null;
    this.city = data?.city ?? null;
    this.state = data?.state ?? null;
    this.country = data?.country ?? null;
    this.postalCode = data?.postalCode ?? null;
    this.taxOffice = data?.taxOffice ?? null;
    this.taxNumber = data?.taxNumber ?? null;
    this.passiveDt = data?.passiveDt ? new Date(data.passiveDt) : null;
    this.authProvider = data?.authProvider ?? null;
    this.notifyToken = data?.notifyToken ?? null;
    this.profilePictureUrl = data?.profilePictureUrl ?? null;
    this.lastSessionBy = data?.lastSessionBy ?? null;
    this.passwordExpireDt = data?.passwordExpireDt ? new Date(data.passwordExpireDt) : null;
    this.isMultiSession = data?.isMultiSession ?? null;
    this.createdBy = data?.createdBy ?? null;
    this.createdDt = data?.createdDt ? new Date(data.createdDt) : null;
    this.updatedBy = data?.updatedBy ?? null;
    this.updatedDt = data?.updatedDt ? new Date(data.updatedDt) : null;

    this.username = data?.username ?? null;
    this.firsName = data?.firsName ?? null;
    this.lastName = data?.lastName ?? null;
    this.email = data?.email ?? null;
    this.role = data?.role ?? null;
  }
}
